<template>
  <el-config-provider :locale="zhCn">
    <div class="app-container" :data-theme="themeStore.currentTheme">
      <!-- <Header />
      <Navigation /> -->
      <div class="main-layout">
        <router-view />
      </div>
    </div>
  </el-config-provider>
</template>

<script lang="ts" setup>
import { ElConfigProvider } from "element-plus";
import zhCn from "element-plus/es/locale/lang/zh-cn";
import { useThemeStore } from "./stores/themeStore";
import { onMounted, watch } from "vue";
import { useRoute } from "vue-router";
import Header from "@/layouts/Header.vue";
import Navigation from "@/layouts/Navigation.vue";

const themeStore = useThemeStore();
const route = useRoute();

// 监听路由变化，强制滚动到顶部
watch(
  () => route.fullPath,
  () => {
    // 使用setTimeout确保在DOM更新后执行滚动
    setTimeout(() => {
      // 强制滚动到顶部，不依赖router的scrollBehavior
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    }, 0);
  },
  { immediate: true }
);

onMounted(() => {
  const link = (document.querySelector("link[rel*='icon']") || document.createElement("link")) as HTMLLinkElement;
  link.type = "image/x-icon";
  link.rel = "shortcut icon";
  document.head.appendChild(link);
  console.log("当前网址", route);
  //link.href = "/images/sxzyydx.ico";
  document.title = "演示平台"
  themeStore.initTheme();
});
</script>

<style lang="scss">
.app-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
  background-color: var(--background-color);
  color: var(--text-color);
  transition:
    background-color 0.3s,
    color 0.3s;

  .main-layout {
    // background: url("@/assets/cqlg.jpg") no-repeat;
    background: url("@/assets/cqlg.jpg") no-repeat;
    background-size: cover;
    background-position: center;
    background-attachment: fixed;
    flex: 1;
    // margin-top: 60px; /* 确保内容不会被固定头部遮挡 */
  }
}
</style>
